import { render, staticRenderFns } from "./SvgPilot.vue?vue&type=template&id=2d9b80dc&"
import script from "./SvgPilot.vue?vue&type=script&lang=js&"
export * from "./SvgPilot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports